import BlokWrap from "@/components/ui/BlokWrap";
import { BloksRoute } from "@/data/routes/bloks.route";
import ProductCard from "@/features/product/components/ProductCard";
import { ProductStoryblok } from "@/generated/sb/sb-types";
import { BlokProps } from "@frend-digital/storyblok";
import styles from "./ProductBlok.module.css";

export const ProductBlok = ({
  blok,
  restProps,
  data,
}: BlokProps<ProductStoryblok, BloksRoute["fetchProductCardById"]> & {
  restProps?: { animation: "fadeY" | "fadeX" | "fadeXinvert" };
}) => {
  if (!blok.product || !data) return <div>Please select a product</div>;

  return (
    <BlokWrap
      className={styles.wrap}
      editable={blok}
      animated={restProps?.animation}
    >
      <div className={styles.inner}>
        <ProductCard product={data} />
      </div>
    </BlokWrap>
  );
};
